module.exports = __webpack_public_path__ + "img/folder_black.794183bf.png";